// Business rule enforced by Dan:
// public catalog products with explicit stock must have at least one item to be shown.
// match-undefined preserves services, bookings, and inquiries that do not use stock.
export const PUBLIC_CATALOG_STOCK_FILTER = Object.freeze({
  minStock: 1,
  stockMode: 'match-undefined',
});
